var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate"},[_c('v-input',{attrs:{"tooltip":"hover","type":"range","interval":1,"value":_vm.value,"min":1,"max":5,"refresh":_vm.refresh},model:{value:(_vm.vmodelvalue),callback:function ($$v) {_vm.vmodelvalue=$$v},expression:"vmodelvalue"}},[_vm._t("default"),_vm._v(": "),_c('b',[_vm._v(_vm._s(_vm.value))])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ed3e68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/components/rate.vue
// module id = null
// module chunks = 